// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26aQ0","content":"styles_content__1zS4X"};